module.exports = __webpack_public_path__ + "static/media/metrocorp-old.b83a7e9b.svg";